import { t } from "i18next";
import * as React from "react";
import { PageLayout } from "src/components/PageLayout";

export const HomePage: React.FC = () => (
  <PageLayout title={t("Title")}>Заглушка для главной страницы</PageLayout>
);
